import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LayoutDashboard, Package, Map, FileText, LogOut, Cake } from "lucide-react";

const navItems = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true, id: "dashboard" },
  { to: "/stock", label: "Manage Stock", icon: Package, id: "stock" },
  { to: "/route-summaries", label: "Route Summaries", icon: Map, id: "route-summaries" },
  { to: "/prep-list", label: "Prep Report", icon: FileText, id: "prep-list" },
];

export default function Layout() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => { logout(); navigate("/login"); };

  return (
    <div className="min-h-screen flex flex-col bg-[#FBF6E9]">
      {/* Top web header */}
      <header className="bg-[#8B4513] shadow-md sticky top-0 z-40">
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center gap-6">
          <div className="flex items-center gap-3 shrink-0">
            <div className="w-9 h-9 rounded-full bg-white/15 flex items-center justify-center">
              <Cake className="w-5 h-5 text-white" />
            </div>
            <div>
              <div className="text-white font-bold leading-tight">Divine Cakery</div>
              <div className="text-[11px] text-[#f0e2cf] leading-tight">Operations Console</div>
            </div>
          </div>

          <nav className="flex items-center gap-1 ml-auto" data-testid="top-nav">
            {navItems.map((t) => (
              <NavLink key={t.to} to={t.to} end={t.end} data-testid={`nav-${t.id}`}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-3.5 py-2 rounded-lg text-sm font-semibold transition-colors ${
                    isActive ? "bg-white text-[#8B4513]" : "text-[#f0e2cf] hover:bg-white/10 hover:text-white"
                  }`}>
                <t.icon className="w-4 h-4" />
                <span className="hidden sm:inline">{t.label}</span>
              </NavLink>
            ))}
            <button onClick={handleLogout} data-testid="logout-button"
              className="ml-2 flex items-center gap-2 px-3.5 py-2 rounded-lg text-sm font-semibold text-[#f0e2cf] hover:bg-white/10 hover:text-white transition-colors" title="Logout">
              <LogOut className="w-4 h-4" /><span className="hidden sm:inline">Logout</span>
            </button>
          </nav>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1 w-full">
        <div className="max-w-6xl mx-auto px-6 py-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
